import { render } from "./predictControl.vue?vue&type=template&id=3cce63b6&scoped=true"
import script from "./predictControl.vue?vue&type=script&lang=js"
export * from "./predictControl.vue?vue&type=script&lang=js"

import "./predictControl.vue?vue&type=style&index=0&id=3cce63b6&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cce63b6"]])

export default __exports__